import { render, staticRenderFns } from "./StationDetailsView.vue?vue&type=template&id=4c7d3c40&scoped=true"
import script from "./StationDetailsView.vue?vue&type=script&lang=ts"
export * from "./StationDetailsView.vue?vue&type=script&lang=ts"
import style0 from "./StationDetailsView.vue?vue&type=style&index=0&id=4c7d3c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d3c40",
  null
  
)

export default component.exports